import { render, staticRenderFns } from "./pushOppoConfig.vue?vue&type=template&id=06e3084c&scoped=true"
import script from "./pushOppoConfig.vue?vue&type=script&lang=js"
export * from "./pushOppoConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e3084c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06e3084c')) {
      api.createRecord('06e3084c', component.options)
    } else {
      api.reload('06e3084c', component.options)
    }
    module.hot.accept("./pushOppoConfig.vue?vue&type=template&id=06e3084c&scoped=true", function () {
      api.rerender('06e3084c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/appBasicSetup/components/pushOppoConfig.vue"
export default component.exports